import ability from './ability'

export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))

export const isRoutingUserPages = to => to.name.match(/^apps-users.*/);

export const isRoutingCompanyPages = to => to.name.match(/^apps-company.*/);

export const _ = undefined
